// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root___Wvxw","approved":"Status_approved__1kQrs","rejected":"Status_rejected__2_zSa","expired":"Status_expired__1g9xv","label":"Status_label__3mx3Q"};